export const adminConstants = {
    ADMIN_GET_LIST_REQUEST: 'ADMIN_GET_LIST_REQUEST',
    ADMIN_GET_LIST_SUCCESS: 'ADMIN_GET_LIST_SUCCESS',
    ADMIN_GET_LIST_FAILURE: 'ADMIN_GET_LIST_FAILURE',


    ADMIN_TYPE_GET_LIST_REQUEST: 'ADMIN_TYPE_GET_LIST_REQUEST',
    ADMIN_TYPE_GET_LIST_SUCCESS: 'ADMIN_TYPE_GET_LIST_SUCCESS',
    ADMIN_TYPE_GET_LIST_FAILURE: 'ADMIN_TYPE_GET_LIST_FAILURE',

    ADMIN_CUSTOMER_LIST_REQUEST: 'ADMIN_CUSTOMER_LIST_REQUEST',
    ADMIN_CUSTOMER_LIST_SUCCESS: 'ADMIN_CUSTOMER_LIST_SUCCESS',
    ADMIN_CUSTOMER_LIST_FAILURE: 'ADMIN_CUSTOMER_LIST_FAILURE',


    ADD_NEW_ADMIN_REQUEST: 'ADD_NEW_ADMIN_REQUEST',
    ADD_NEW_ADMIN_SUCCESS: 'ADD_NEW_ADMIN_SUCCESS',
    ADD_NEW_ADMIN_FAILURE: 'ADD_NEW_ADMIN_FAILURE',

    UPDATE_ADMIN_REQUEST: 'UPDATE_ADMIN_REQUEST',
    UPDATE_ADMIN_SUCCESS: 'UPDATE_ADMIN_SUCCESS',
    UPDATE_ADMIN_FAILURE: 'UPDATE_ADMIN_FAILURE',

    ADMIN_BLOCK_REQUEST: 'ADMIN_BLOCK_REQUEST',
    ADMIN_BLOCK_SUCCESS: 'ADMIN_BLOCK_SUCCESS',
    ADMIN_BLOCK_FAILURE: 'ADMIN_BLOCK_FAILURE',

    ADMIN_DELETE_REQUEST: 'ADMIN_DELETE_REQUEST',
    ADMIN_DELETE_SUCCESS: 'ADMIN_DELETE_SUCCESS',
    ADMIN_DELETE_FAILURE: 'ADMIN_DELETE_FAILURE',

    ADMIN_GET_ASSIGNED_IDS_REQUEST: 'ADMIN_GET_ASSIGNED_IDS_REQUEST',
    ADMIN_GET_ASSIGNED_IDS_SUCCESS: 'ADMIN_GET_ASSIGNED_IDS_SUCCESS',
    ADMIN_GET_ASSIGNED_IDS_FAILURE: 'ADMIN_GET_ASSIGNED_IDS_FAILURE',
}